import Proxy from './Proxy';

class AssessmentProxy extends Proxy {
  /**
   * The constructor for the CareplanProxy.
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super('/PatientAssessments', parameters);
  }

  /**
   * Method used to view user profile.
   *
   * @param {id} id.
   *
   * @returns {Promise} The result in a promise.
   */
  getAssessments(data) {
    return this.submit('post', `${this.endpoint}/list`, data);
  }

  getAssessmentSymptoms() {
    return this.submit('get', '/AssessmentSymptoms');
  }
}

export default AssessmentProxy;
